export default __webpack_public_path__ + "static/media/james_prado_roberts_modal.9840a3c6.jpg";